module.exports = __webpack_public_path__ + "static/icons/intersport__rewards--icon-f1b14f4a5f873780340315c7ae81a9d2.svg";